var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g({ref:"image",class:['tkImage', { '-suppressHighlight': _vm.suppressHighlight }],style:([
    _vm.height ? { 'height': `${_vm.height}px` } : {},
    _vm.objectFit ? { 'object-fit': _vm.objectFit } : {},
  ]),attrs:{"src":_vm.srcImagePath,"alt":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }